import BaseCrudService from "./baseCrud.service";

// Performance: cache estático por fileId — evita re-fetch do mesmo arquivo entre instâncias
const _renderCache = {};
const _renderPending = {};

export default class FileService extends BaseCrudService {

	constructor() {
		super('File');
	}

	render(fileId) {
		if(fileId == 0 || fileId == null) return Promise.resolve({ data: "" });

		// Performance: retorna cache se já carregado
		if (_renderCache[fileId]) return Promise.resolve(_renderCache[fileId]);

		// Performance: deduplicação — retorna promise in-flight se já em andamento
		if (_renderPending[fileId]) return _renderPending[fileId];

		_renderPending[fileId] = this.getRequest('Render', { id: fileId }, true, false)
			.then(data => {
				_renderCache[fileId] = data;
				delete _renderPending[fileId];
				return data;
			})
			.catch(err => {
				delete _renderPending[fileId];
				throw err;
			});

		return _renderPending[fileId];
	}

	getById(fileId) {
		return this.getRequest('GetById', { id: fileId }, true, false);
	}
}